// extracted by mini-css-extract-plugin
module.exports = {"pageMaxWidth":"500px","designMobileWidth":"360px","designMobileHeight":"780px","designWidth":"1440px","designHeight":"1024px","enableScaling":"true"};